import * as types from '@/store/mutations'
import api from '@/services/team.js'


const getters = {
    teammembers: (state)=> state.teammembers,
    getMembers: (state) => () => {
        return state.teammembers
    }

}

const actions = {
  loadTeamdata({ commit }) {
    return new Promise((resolve, reject) => {
      api.getTeammembers().then((res)=>{
        commit(types.SET_ALL_TEAMMEMBERS,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  loadTeamBonusdata({ commit }) {
    return new Promise((resolve, reject) => {
      api.getTeambonus().then((res)=>{
        commit(types.SET_ALL_TEAMMEMBERS,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  loadTeamWeekByWeekStats({ commit }) {
    return new Promise((resolve, reject) => {
      api.getTeammembers().then((res)=>{
        commit(types.SET_ALL_TEAMMEMBERS,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },

  loadPerformancedata( context, payload) {
    return new Promise((resolve, reject) => {
      api.getTeamPerformance(payload).then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  loadTeamThisWeek({ commit }) {
    return new Promise((resolve, reject) => {
      api.getTeamThisWeek().then((res)=>{
        commit(types.SET_ALL_TEAMTHISWEEK,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  loadTeamTripdata({ commit }) {
    return new Promise((resolve, reject) => {
      api.getTeamTripdata().then((res)=>{
        commit(types.SET_ALL_TEAMTRIPDATA,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  loadAdminTripdata({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAdminTripdata().then((res)=>{
        commit(types.SET_ALL_ADMINTRIPDATA,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  loadTeamCampaigndata({ commit }) {
    return new Promise((resolve, reject) => {
      api.getTeamCampaigndata().then((res)=>{
        commit(types.SET_ALL_TEAMCAMPAIGNDATA,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },

  loadTeamSettings({ commit }) {
    return new Promise((resolve, reject) => {
      api.getTeamsettings().then((res)=>{
        commit(types.SET_ALL_TEAMMEMBERS,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  storeTeamSettings(context, payload  ) {
    return new Promise((resolve, reject) => {
      api.setTeamsettings(payload).then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  loadWhatProductsForWeek(context, params){
    return new Promise((resolve, reject) => {
      api.getTopProducts(params).then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })    
  },
  loadWhoBoughtThat(context, params){
    return new Promise((resolve, reject) => {
      api.getWhoBoughtThat(params).then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })    
  },




}

const mutations = {
  [types.SET_ALL_TEAMMEMBERS](state, teammembers) {
    state.teamteammembers = teammembers
  },
  [types.SET_ALL_TEAMTHISWEEK](state, teamthisweek) {
    state.teamthisweek = teamthisweek
  },
  [types.SET_ALL_TEAMTRIPDATA](state, teamtripdata) {
    state.teamtripdata = teamtripdata
  },
  [types.SET_ALL_TEAMCAMPAIGNDATA](state, teamcampaigndata) {
    state.teamcampaigndata = teamcampaigndata
  },
  [types.SET_ALL_ADMINTRIPDATA](state, admintripdata) {
    state.admintripdata = admintripdata
  }

}

const state = {
  teammembers: [],
  teamthisweek: [],
  teamtripdata: [],
  teamcampaigndata: [],
  admintripdata: []
}

export default {
  state,
  getters,
  actions,
  mutations
}
